import type { Payload } from '@/api/interfaces/payload';
import type { AccountUser } from '@/api/interfaces/user/account-user';
import httpClient from '@/helpers/client/http-client';
import type { AxiosPromise } from 'axios';

export function getAccountUser(
  abortController: AbortController = new AbortController(),
): AxiosPromise<Payload<AccountUser>> {
  return httpClient.get('/users/me', {
    signal: abortController.signal,
  });
}
